import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneOpportunitiesObtained = createAsyncThunk(
  "GetOneOpportunitiesObtained/GetOneOpportunitiesObtained",
  async (pR_OpportunitiesObtainedId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_OpportunitiesObtained/GetPR_OpportunitiesObtainedData",
        {
          pR_OpportunitiesObtainedId: pR_OpportunitiesObtainedId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteOpportunitiesObtained = createAsyncThunk(
  "DeleteOpportunitiesObtained/DeleteOpportunitiesObtained",
  async (pR_OpportunitiesObtainedId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_OpportunitiesObtained/DeletePR_OpportunitiesObtainedData",
        {
          pR_OpportunitiesObtainedId: pR_OpportunitiesObtainedId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListOpportunitiesObtained = createAsyncThunk(
  "GetListOpportunitiesObtained/GetListOpportunitiesObtained",
  async (pR_ReportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_OpportunitiesObtained/GetPR_OpportunitiesObtainedListData",
        {
          pR_ReportsStagesGuid: pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateOpportunitiesObtainedData = createAsyncThunk(
  "UpdateOpportunitiesObtainedData/UpdateOpportunitiesObtainedData",
  async (OpportunitiesObtainedData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_OpportunitiesObtained/UpdatePR_OpportunitiesObtainedData",
        {
          pR_OpportunitiesObtainedId:
            OpportunitiesObtainedData.pR_OpportunitiesObtainedId,
          opportunityDetails: OpportunitiesObtainedData.opportunityDetails,
          utilizationMechanism: OpportunitiesObtainedData.utilizationMechanism,
          dateOfOpportunity: OpportunitiesObtainedData.dateOfOpportunity,
          entityProvidingOpportunity:
            OpportunitiesObtainedData.entityProvidingOpportunity,
          pR_ReportsStagesGuid: OpportunitiesObtainedData.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddOpportunitiesObtainedData = createAsyncThunk(
  "AddOpportunitiesObtainedData/AddOpportunitiesObtainedData",
  async (OpportunitiesObtainedData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_OpportunitiesObtained/AddPR_OpportunitiesObtainedData",
        {
          opportunityDetails: OpportunitiesObtainedData.opportunityDetails,
          utilizationMechanism: OpportunitiesObtainedData.utilizationMechanism,
          dateOfOpportunity: OpportunitiesObtainedData.dateOfOpportunity,
          entityProvidingOpportunity:
            OpportunitiesObtainedData.entityProvidingOpportunity,
          pR_ReportsStagesGuid: OpportunitiesObtainedData.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateOpportunitiesObtained = createAsyncThunk(
  "ValidateOpportunitiesObtained/ValidateOpportunitiesObtained",
  async (OpportunitiesObtainedData, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_OpportunitiesObtained/ValidatePR_OpportunitiesObtainedData",
        {
          opportunityDetails: OpportunitiesObtainedData.opportunityDetails,
          utilizationMechanism: OpportunitiesObtainedData.utilizationMechanism,
          dateOfOpportunity: OpportunitiesObtainedData.dateOfOpportunity,
          entityProvidingOpportunity:
            OpportunitiesObtainedData.entityProvidingOpportunity,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteOpportunitiesObtained = createAsyncThunk(
  "GetSpecificRowNoteOpportunitiesObtained/GetSpecificRowNoteOpportunitiesObtained",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data.filter((item) => item.incrementNumber - 1 === 1);
      //   return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OpportunitiesObtained = createSlice({
  name: "OpportunitiesObtained",
  initialState: {
    OneOpportunitiesObtained: {},
    loadingOneOpportunitiesObtained: false,
    errorOneOpportunitiesObtained: null,

    AddOpportunitiesObtained: {},
    loadingAddOpportunitiesObtained: false,
    errorAddOpportunitiesObtained: null,

    UpdateOpportunitiesObtained: {},
    loadingUpdateOpportunitiesObtained: false,
    errorUpdateOpportunitiesObtained: null,

    DeleteOpportunitiesObtained: {},
    loadingDeleteOpportunitiesObtained: false,
    errorDeleteOpportunitiesObtained: null,

    ListOpportunitiesObtained: {},
    loadingListOpportunitiesObtained: false,
    errorListOpportunitiesObtained: null,

    OpportunitiesObtainedValidate: [],
    loadingOpportunitiesObtainedValidate: false,
    errorOpportunitiesObtainedValidate: null,

    OneSpecificRowNoteOpportunitiesObtained: {},
    loadingOneSpecificRowNoteOpportunitiesObtained: false,
    errorOneSpecificRowNoteOpportunitiesObtained: null,
  },
  reducers: {
    restValidateOpportunitiesObtained: (state, action) => {
      state.OpportunitiesObtainedValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetOneOpportunitiesObtained.pending, (state, action) => {
        state.loadingOneOpportunitiesObtained = true;
        state.OneOpportunitiesObtained = action.payload;
        state.errorOneOpportunitiesObtained = null;
      })
      .addCase(GetOneOpportunitiesObtained.fulfilled, (state, action) => {
        state.loadingOneOpportunitiesObtained = false;
        state.OneOpportunitiesObtained = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneOpportunitiesObtained.rejected, (state, action) => {
        state.loadingOneOpportunitiesObtained = false;
        state.errorOneOpportunitiesObtained = action.payload;
      })

      .addCase(DeleteOpportunitiesObtained.pending, (state, action) => {
        state.loadingDeleteOpportunitiesObtained = true;
        state.DeleteOpportunitiesObtained = action.payload;
        state.errorDeleteOpportunitiesObtained = null;
      })
      .addCase(DeleteOpportunitiesObtained.fulfilled, (state, action) => {
        state.DeleteOpportunitiesObtained = false;
        state.DeleteOpportunitiesObtained = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteOpportunitiesObtained.rejected, (state, action) => {
        state.loadingDeleteOpportunitiesObtained = false;
        state.errorDeleteOpportunitiesObtained = action.payload;
      })
      .addCase(GetListOpportunitiesObtained.pending, (state, action) => {
        state.loadingListOpportunitiesObtained = true;
        state.ListOpportunitiesObtained = action.payload;
        state.errorListOpportunitiesObtained = null;
      })
      .addCase(GetListOpportunitiesObtained.fulfilled, (state, action) => {
        state.loadingListOpportunitiesObtained = false;
        state.ListOpportunitiesObtained = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListOpportunitiesObtained.rejected, (state, action) => {
        state.loadingListOpportunitiesObtained = false;
        state.errorListOpportunitiesObtained = action.payload;
      })
      .addCase(UpdateOpportunitiesObtainedData.pending, (state, action) => {
        state.loadingUpdateOpportunitiesObtained = true;
        state.UpdateOpportunitiesObtained = action.payload;
        state.errorUpdateOpportunitiesObtained = null;
      })
      .addCase(UpdateOpportunitiesObtainedData.fulfilled, (state, action) => {
        state.loadingUpdateOpportunitiesObtained = false;
        state.UpdateOpportunitiesObtained = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateOpportunitiesObtainedData.rejected, (state, action) => {
        state.loadingUpdateOpportunitiesObtained = false;
        state.errorUpdateOpportunitiesObtained = action.payload;
      })
      .addCase(ValidateOpportunitiesObtained.pending, (state, action) => {
        state.loadingOpportunitiesObtainedValidate = true;
        state.OpportunitiesObtainedValidate = action.payload;
        state.errorOpportunitiesObtainedValidate = null;
      })
      .addCase(ValidateOpportunitiesObtained.fulfilled, (state, action) => {
        state.loadingOpportunitiesObtainedValidate = false;
        state.OpportunitiesObtainedValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateOpportunitiesObtained.rejected, (state, action) => {
        state.loadingOpportunitiesObtainedValidate = false;
        state.errorOpportunitiesObtainedValidate = action.payload;
      })
      .addCase(AddOpportunitiesObtainedData.pending, (state, action) => {
        state.loadingAddOpportunitiesObtained = true;
        state.AddOpportunitiesObtained = action.payload;
        state.errorAddOpportunitiesObtained = null;
      })
      .addCase(AddOpportunitiesObtainedData.fulfilled, (state, action) => {
        state.loadingAddOpportunitiesObtained = false;
        state.AddOpportunitiesObtained = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddOpportunitiesObtainedData.rejected, (state, action) => {
        state.loadingAddOpportunitiesObtained = false;
        state.errorAddOpportunitiesObtained = action.payload;
      })

      .addCase(
        GetSpecificRowNoteOpportunitiesObtained.pending,
        (state, action) => {
          state.loadingOneSpecificRowNoteOpportunitiesObtained = true;
          state.OneSpecificRowNoteOpportunitiesObtained = action.payload;
          state.errorOneSpecificRowNoteOpportunitiesObtained = null;
        }
      )
      .addCase(
        GetSpecificRowNoteOpportunitiesObtained.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteOpportunitiesObtained = false;
          state.OneSpecificRowNote = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificRowNoteOpportunitiesObtained.rejected,
        (state, action) => {
          state.loadingOneSpecificRowNoteOpportunitiesObtained = false;
          state.errorOneSpecificRowNoteOpportunitiesObtained = action.payload;
        }
      );
  },
});
export const { restValidateOpportunitiesObtained } =
  OpportunitiesObtained.actions;
export default OpportunitiesObtained.reducer;
